export { FooterLegalComponent } from './components/footer-legal/footer-legal.component';
export { FooterNavigationComponent } from './components/footer-navigation/footer-navigation.component';
export { FooterSocialComponent } from './components/footer-social/footer-social.component';
export { FooterComponent } from './components/footer/footer.component';
export * from './footer.module';
